import { render, staticRenderFns } from "./SaleCta.vue?vue&type=template&id=36b6197d"
import script from "./SaleCta.vue?vue&type=script&lang=js"
export * from "./SaleCta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports